import React from "react"
import styled from "styled-components"
import { inject, observer } from "mobx-react"

import FormError from "~/components/Form/ErrorText"
import withTranslations from "~/components/_hocs/withTranslations"
import constants from "~/style/constants"

const PadlockIcon = styled.span`
  display: inline-flex;
  width: 14px;
  height: 14px;
  color: ${(p) => p.theme?.colors?.text?.subContent || "#9e9e9e"};
`
const padlockSvg = (
  <svg viewBox="0 0 24 24" fill="currentColor" width="100%" height="100%">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
  </svg>
)

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

const LabelRow = styled.label`
  font-family: ${(p) => p.theme?.fonts?.avenirNextMedium || "inherit"};
  font-size: 0.9375rem;
  color: #374553;
  height: 21px;
  display: flex;
  align-items: center;
  gap: 6px;
`

const Input = styled.input.attrs({ type: "password", inputMode: "numeric", maxLength: 4 })`
  width: 100%;
  height: 70px;
  padding: 0 20px;
  font-family: ${(p) => p.theme?.fonts?.avenirNextRegular || "inherit"};
  font-size: 1rem;
  letter-spacing: 0.5em;
  text-align: center;
  background: #fff;
  border: 1px solid ${(p) => (p.$error ? p.theme?.colors?.error : constants.colors.ui.borderGray)};
  border-radius: 4px;
  outline: none;
  box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  color: ${(p) => p.theme?.colors?.text?.input ?? "#374553"};
  caret-color: ${(p) => p.theme?.colors?.primary};
  -webkit-appearance: none;
  appearance: none;

  &::placeholder {
    color: ${(p) => p.theme?.colors?.text?.inputPlaceholder ?? "rgba(25,25,27,0.4)"};
  }

  @media (max-width: 768px) {
    height: 56px;
    font-size: 0.9rem;
    letter-spacing: 0.4em;
  }

  @media (max-width: 480px) {
    height: 48px;
    font-size: 0.85rem;
    letter-spacing: 0.35em;
  }
`

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8125rem;
  color: ${(p) => p.theme?.colors?.text?.subContent || "#9e9e9e"};
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  SSN: all.store.trafficLookup.SSN,
  setLast4SSN: all.store.trafficLookup.setLast4SSN,
}))
@observer
class Last4SSNSecure extends React.Component {
  handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4)
    this.props.setLast4SSN(value)
  }

  render() {
    const { translate, SSN, validateDisplayMessage } = this.props
    const error = validateDisplayMessage("SSN")

    return (
      <Wrap>
        <LabelRow>
          {translate("label")}
          <PadlockIcon aria-hidden>{padlockSvg}</PadlockIcon>
        </LabelRow>
        <Input
          placeholder="••••"
          value={SSN}
          onChange={this.handleChange}
          $error={!!error}
          aria-invalid={!!error}
          aria-label={translate("label")}
        />
        <Footer>
          <PadlockIcon aria-hidden>{padlockSvg}</PadlockIcon>
          {translate("encryptedSecure")}
        </Footer>
        <FormError error={error} />
      </Wrap>
    )
  }
}

export default withTranslations(Last4SSNSecure, "form.traffic.lastFourSSN")
